module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Medium.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-medium/MiloOffc-Medium.svg
// module id = 518
// module chunks = 0